import o, { useEffect as f } from "react";
import { paymentStatusReducer as s, IDLE_PAYMENT_STATUS as n } from "../hooks/paymentStatus.js";
import { usePaymentRedirectVerification as p } from "../hooks/usePaymentRedirectVerification.js";
import { redirectVerificationToEvent as u } from "../hooks/redirectVerificationToEvent.js";
import { ProcessingPaymentScreen as y } from "../ProcessingPaymentScreen/ProcessingPaymentScreen.js";
function T({
  gatewayToken: c,
  design: i,
  onSucceeded: m,
  onFailed: e
}) {
  const t = p({ gatewayToken: c });
  f(() => {
    t.status === "accepted" && t.payment ? m(t.payment) : t.status === "failed" && (e == null || e(t.error ?? new Error("Payment failed")));
  }, [t.status]);
  const r = u(t), a = r ? s(n, r) : n;
  return /* @__PURE__ */ o.createElement(y, { paymentStatus: a, design: i });
}
export {
  T as RedirectPaymentScreen
};
//# sourceMappingURL=RedirectPaymentScreen.js.map
